import { render, staticRenderFns } from "./ViewSurveyAggregates.vue?vue&type=template&id=9da9335c&scoped=true"
import script from "./ViewSurveyAggregates.vue?vue&type=script&lang=js"
export * from "./ViewSurveyAggregates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da9335c",
  null
  
)

export default component.exports